import type { ReactNode } from 'react'
import { useI18n } from '../../i18n'
import { Button } from '../ui/Button'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

type Props = {
  open: boolean
  title: ReactNode
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  titleId?: string
}

export function GovernancePickerModal({ open, title, onClose, children, footer, titleId }: Props) {
  const { t } = useI18n()
  const headingId = titleId || 'governance-picker-modal-title'

  if (!open) return null

  return (
    <div className={listStyles.pickerModalOverlay} role="presentation">
      <button
        type="button"
        className={listStyles.pickerModalBackdrop}
        aria-label={t('common.close', 'Close')}
        onClick={onClose}
      />
      <div
        className={listStyles.pickerModalShell}
        role="dialog"
        aria-modal="true"
        aria-labelledby={headingId}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={listStyles.pickerModalHeader}>
          <h3 id={headingId} className={listStyles.pickerModalTitle}>
            {title}
          </h3>
          <Button type="button" size="small" color="outline" className="shrink-0" onClick={onClose}>
            {t('common.close', 'Close')}
          </Button>
        </div>
        <div className={listStyles.pickerModalBody}>{children}</div>
        {footer ? <div className={listStyles.pickerModalFooter}>{footer}</div> : null}
      </div>
    </div>
  )
}

export default GovernancePickerModal
